/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoDataResult/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoDataResult({
  children,
  viewPath = "/DesignSystem/Images/NoDataResult",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 300,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 300
  
}) {
  return (<React.Fragment
>
<img
  data-testid="NoDataResult.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z1K09u6': alignSelf,'--bc-2-Z1K09u6': backgroundColor,'--bblr-3-Z1K09u6': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z1K09u6': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1K09u6': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1K09u6': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z1K09u6': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z1K09u6': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z1K09u6': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z1K09u6': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z1K09u6': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z1K09u6': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}